import React, { useState, useEffect } from 'react';
import { t } from 'ttag';

import '../styles.css';

export default function PopularCategories() {
  const [popularCategories, setPopularCategories] = useState(
    /** @type {Array<{name: string, link: string, page_views: number}>} */ []
  );

  useEffect(() => {
    const fetchPopularCategories = async () => {
      const response = await fetch(`/api/categories/popular/`);
      const data = await response.json();
      if (data) {
        setPopularCategories(data);
      }
    };

    fetchPopularCategories();
  }, []);

  return (
    <section className="g:py-28 min-h-[192px] space-y-6 px-3 py-20 pl-3">
      <h2 className="m-0 p-0 text-left text-sm font-semibold uppercase text-dark-gray before:mb-4 before:h-[1px] before:bg-gray/80 before:content-['']">{t`Popular Categories`}</h2>
      <div>
        <ul className="m-0 grid list-none grid-cols-2 gap-2 gap-x-8 md:grid-cols-4 lg:w-auto lg:min-w-[1024px] lg:grid-cols-6 lg:gap-x-4">
          {popularCategories?.map(({ name, link }) => (
            <li
              key={name}
              className="mb-2 line-clamp-1 w-fit text-sm md:text-xs "
            >
              <a
                href={`/${link}`}
                className="block font-semibold text-black no-underline hover:underline"
              >
                {name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
